import * as React from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import './BuildingDetails.css';
import { handleNextStep, setStep, setQuoteData } from '../../../../actions/salesActions';

class AlternativePower extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            currencySymbol: this.props.profile.currencySymbol + " ",
            submitted: false,
            nextDisabled: false,
            replacementValue: this.props.sales.buildingAdditionalDetail?.alternativePower_replacementValue ?? null,
        };

        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleChangeValue = this.handleChangeValue.bind(this);
    }

    handleChangeValue(e: any) {
        let value = e.target.value.toString().substring(this.state.currencySymbol.length);
        value = value !== "" ? value : null;
        this.setState({ replacementValue: value }, () => this.checkSubmit());
    }

    componentDidMount() {
        this.checkSubmit();
    }

    checkSubmit() {
        let valid = (this.state.replacementValue !== null);
        this.setState({ nextDisabled: !valid });
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            let buildingAdditionalDetail = {
                ...this.props.sales.buildingAdditionalDetail,
                alternativePower_replacementValue: this.state.replacementValue
            };
            this.props.dispatchAction(setQuoteData({ buildingAdditionalDetail }));
            if (this.props.sales.buildingAdditional.thatchRoof || this.props.sales.buildingAdditional.thatchLapa) {
                this.props.dispatchAction(handleNextStep());
            }
            else {
                this.props.dispatchAction(setStep(10, 1));
            }
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="mb-4 text-center">
                    Thanks. What’s the estimated replacement value of the alternative power system?
                </div>

                <div className="ssp-inputtextarea-input-element-container mt-4">
                    <div className={"form-group noma" + (this.state.submitted && (this.state.replacementValue === null ) ? ' has-error' : '')}>
                        <label className={'text-left label-style form-label font-size-14px line-height-normal mb-6px ' + (this.state.replacementValue !== null ? "" : " d-none")}>Replacement value</label>
                        <div>
                            <NumberFormat
                                id={"txtAlternativePowerValue" + this.props.id}
                                name={"txtAlternativePowerValue" + this.props.id}
                                placeholder={this.state.currencySymbol }
                                thousandSeparator={true}
                                thousandsGroupStyle="thousand"
                                prefix={this.state.currencySymbol}
                                value={this.state.replacementValue ?? ""}
                                required={true}
                                className="ssp-inputtextarea-input-element"
                                onChange={this.handleChangeValue}
                            />
                        </div>
                        {this.state.submitted && (this.state.replacementValue === null) &&
                            <div className="form-inline-error"> Replacement value is required</div>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 justify-content-center mt-5">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AlternativePower);